import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.092 1.875h2.818c.18 0 .338 0 .486.023.586.094 1.093.46 1.367.986.07.133.12.282.176.453l.093.28.024.07a1.04 1.04 0 0 0 1.029.688h2.5a.625.625 0 1 1 0 1.25H3.418a.625.625 0 1 1 0-1.25h2.575a1.04 1.04 0 0 0 .977-.758l.093-.28c.057-.17.107-.32.176-.453a1.88 1.88 0 0 1 1.368-.986c.148-.023.305-.023.485-.023m-1.084 2.5q.064-.126.114-.262l.032-.094.083-.25c.076-.228.094-.274.111-.308a.63.63 0 0 1 .456-.328c.037-.006.086-.008.327-.008h2.741c.24 0 .29.002.327.008a.63.63 0 0 1 .456.328c.017.034.035.08.11.308l.084.25.032.094q.049.136.114.262z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.43 7.042a.625.625 0 1 0-1.247.083l.387 5.793c.07 1.069.128 1.933.263 2.61.14.704.38 1.293.872 1.754.493.461 1.096.66 1.808.753.685.09 1.55.09 2.622.09h.733c1.07 0 1.936 0 2.621-.09.712-.093 1.315-.292 1.808-.753s.732-1.05.872-1.754c.135-.678.193-1.541.264-2.61l.386-5.793a.625.625 0 1 0-1.247-.083l-.383 5.75c-.075 1.122-.128 1.904-.245 2.492-.114.57-.273.872-.5 1.085-.228.213-.54.352-1.117.427-.594.078-1.378.079-2.503.079h-.645c-1.126 0-1.909-.001-2.503-.079-.577-.075-.889-.214-1.117-.427s-.386-.515-.5-1.085c-.117-.588-.17-1.37-.245-2.493z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.356 8.545a.625.625 0 0 1 .684.56l.417 4.166a.625.625 0 0 1-1.244.125l-.417-4.167a.625.625 0 0 1 .56-.684M12.647 8.545c.343.034.594.34.56.684l-.417 4.167a.625.625 0 0 1-1.244-.125l.417-4.166a.625.625 0 0 1 .684-.56"
    }, null, -1)
  ])))
}
export default { render: render }